module.exports = __webpack_public_path__ + "img/logo_dk_top.30b2ee68.png";